import axios from "axios";

export const REST = axios.create({
  baseURL: siteGlobals.baseUrl + "/wp-json/cabbi/v1/"
});
